<template>
  <div>
    <SubjectFillType
      :role-type="roleType"
      :loading-next="loadingNext"
      :statement-type="statementType"
      :subject-name="SubjectName.DEBTOR"
      @prev="$emit(StepDirection.PREV, $event)"
      @next="$emit(StepDirection.NEXT, $event)"
    />
  </div>
</template>

<script>
import SubjectFillType from '@/components/services/common/SubjectFillType';
import { StepDirection } from '@/types/services';
import { SubjectName } from '@/constants';

export default {
  name: 'DebtorFillType',
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
    roleType: {
      type: String,
      required: true,
    },
    statementType: {
      type: String,
      required: true,
    },
  },
  components: {
    SubjectFillType,
  },
  data: () => ({
    SubjectName,
    StepDirection,
  }),
};
</script>
